const atencionSinTurnoInitialState = {
    atencionSinTurno: {
      data: [],
      loading: false,
      error: false,
      centros: [], 
    },
  };
  
  export default atencionSinTurnoInitialState;
  